var map = {
	"./sel_Beijing.png": "4033",
	"./sel_Chengdu.png": "bad3",
	"./sel_Dalian.png": "9680",
	"./sel_Guangzhou.png": "94fd",
	"./sel_Hangzhou.png": "5cd3",
	"./sel_Hong Kong.png": "0958",
	"./sel_Shanghai.png": "2f06",
	"./sel_Shenzhen.png": "2bf7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac1e";